export const CardsMode = {
  Listen: 'listen',
  Translate: 'translate',
  StudyingCards: 'studying-cards',
} as const

export type CardsMode = (typeof CardsMode)[keyof typeof CardsMode]
